<template>
	<div class="contact-us-page">
		<div class="contact-us-page__container">
			<div class="contact-us-page__primary">
				<section class="contact-us-page__section">
					<div
						class="contact-us-page__image contact-us-page__image--phone"
					>
						<i class="icon icon-phone"></i>
					</div>
					<div class="contact-us-page__content">
						<h3 class="contact-us-page__title">Phone</h3>
						<span class="contact-us-page__text"
							>1-800-227-8187</span
						>
					</div>
				</section>

				<section class="contact-us-page__section">
					<div class="contact-us-page__image">
						<i class="icon icon-contact-email"></i>
					</div>
					<div class="contact-us-page__content">
						<h3 class="contact-us-page__title">Email</h3>
						<ul class="contact-us-page__list">
							<li class="contact-us-page__item">
								<label
									class="contact-us-page__label"
									for="support"
									>Support</label
								>
								<Hyperlink
									class="contact-us-page__link"
									href="mailto:dmssupport@dominiondms.com"
									labelText="dmssupport@dominiondms.com"
								/>
							</li>
							<li class="contact-us-page__item">
								<label
									class="contact-us-page__label"
									for="marketing"
									>Marketing</label
								>
								<Hyperlink
									class="contact-us-page__link"
									href="mailto:dms_marketing@dominiondms.com"
									labelText="dms_marketing@dominiondms.com"
								/>
							</li>
							<li class="contact-us-page__item">
								<label
									class="contact-us-page__label"
									for="accounting and payroll"
									>Accounting and Payroll</label
								>
								<Hyperlink
									class="contact-us-page__link"
									href="mailto:dms_ap@dominiondms.com"
									labelText="dms_ap@dominiondms.com"
								/>
							</li>
							<li class="contact-us-page__item">
								<label
									class="contact-us-page__label"
									for="parts and service"
									>Parts and Service</label
								>
								<Hyperlink
									class="contact-us-page__link"
									href="mailto:dms_ps@dominiondms.com"
									labelText="dms_ps@dominiondms.com"
								/>
							</li>
							<li class="contact-us-page__item">
								<label
									class="contact-us-page__label"
									for="sales and fi"
									>Sales and F&amp;I</label
								>
								<Hyperlink
									class="contact-us-page__link"
									href="mailto:dms_sl@dominiondms.com"
									labelText="dms_sl@dominiondms.com"
								/>
							</li>
						</ul>
					</div>
				</section>
			</div>

			<div class="contact-us-page__secondary">
				<section class="contact-us-page__section">
					<div
						class="contact-us-page__image contact-us-page__image--website"
					>
						<i class="icon icon-web"></i>
					</div>
					<div class="contact-us-page__content">
						<h3 class="contact-us-page__title">Website</h3>
						<Hyperlink
							class="contact-us-page__link"
							href="https://www.VUEDMS.com/"
							labelText="www.VUEDMS.com"
						/>
					</div>
				</section>

				<section class="contact-us-page__section">
					<div class="contact-us-page__image">
						<i class="icon icon-contact-location"></i>
					</div>
					<div class="contact-us-page__content">
						<h3 class="contact-us-page__title">Mailing Address</h3>
						<span class="contact-us-page__text"
							>150 Granby Street <br />
							Norfolk, VA 23510</span
						>
						<Hyperlink
							class="contact-us-page__link"
							href="https://www.google.com/maps?q=150+Granby+Street,+Norfolk,+VA+23510"
							labelText="View on Google Maps"
						/>
					</div>
				</section>

				<section
					class="contact-us-page__support contact-us-page__section--support"
				>
					<div
						class="contact-us-page__image contact-us-page__image--support"
					>
						<i class="icon icon-remote-support"></i>
					</div>
					<div class="contact-us-page__content">
						<label
							class="contact-us-page__label"
							for="remote support"
							>Remote Support</label
						>
						<Hyperlink
							class="contact-us-page__link"
							href="https://get.teamviewer.com/dmssupport"
							labelText="https://get.teamviewer.com/dmssupport"
						/>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
import Hyperlink from '@/components/typography/hyperlink/hyperlink.vue';

export default {
	name: 'ContactUs',
	components: {
		Hyperlink
	},
	metaInfo: {
		title: 'Contact Us'
	}
};
</script>

<style lang="scss" scoped>
.contact-us-page {
	&__container {
		display: grid;
		grid-template-columns: 1fr;
		gap: $gutter-xxl;
		margin-top: $gutter-xxl;
		padding-bottom: $padding-xl;

		@include mq($from: md) {
			grid-template-columns: 1fr 1fr;
		}
	}

	&__primary,
	&__secondary {
		display: flex;
		flex-direction: column;
		gap: $gutter-xxl;
	}

	&__section {
		gap: $padding-md;
		display: inline-flex;
		font-size: $txt-font-size;

		&:not(.contact-us-page__section--support) {
			.contact-us-page__content {
				padding-top: $padding-sm;
			}
		}
	}

	&__section--support {
		display: inline-flex;
		gap: $padding-md;
		background-color: var(--bg-2);
		color: var(--bg-2-fg-3);
		padding: $padding-md $padding-lg;
		max-width: fit-content;
		border-radius: $border-radius;
	}

	&__image {
		font-size: 28px;
		border-radius: 50%;
		width: 44px;
		height: 44px;
		background-color: var(--bg-2);
		border: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		color: var(--bg-2-fg-2);

		&--phone {
			font-size: 22px;
		}

		&--website .icon {
			padding: 2px 0 3px 2px;
		}

		&--support {
			width: auto;
			height: auto;

			@include mq($from: md-l) {
				font-size: 37px;
			}
		}
	}

	&__title {
		@include heading('lg');
	}

	&__label {
		@include heading('sm');
	}

	&__label,
	&__text {
		display: block;
	}

	&__list {
		list-style-type: none;
	}

	&__item:not(:first-child) {
		margin-top: $gutter-lg;
	}
}
</style>
